import React from "react";

// "Year 5712" landing indicator, shown when a query is about a specific year.
// Renders nothing when there is no resolved year.
export default function RagYearBanner({ year }) {
  if (!year || !year.year) return null;
  return (
    <div className="rounded-lg bg-primaryBlue bg-opacity-10 border border-primaryBlue p-4 mb-6">
      <div className="font-extrabold text-primaryDark text-lg">Year {year.year}</div>
    </div>
  );
}
